import {
  Loader,
  Select,
  SelectItem,
  SelectSearch,
} from '@energybox/react-ui-library/dist/components';
import { TimeZone } from '@energybox/react-ui-library/dist/types';
import { hasSubstr } from '@energybox/react-ui-library/dist/utils';

import React from 'react';
import { connect } from 'react-redux';
import { getTimeZones } from '../actions/app';
import { ApplicationState } from '../reducers';

interface OwnProps {
  onSelect: (timezone: string) => void;
  value?: string;
  error?: boolean;
  customErrorText?: string;
}

interface Props extends OwnProps {
  getTimeZones: typeof getTimeZones;
  timezones?: TimeZone[];
}

interface State {
  search: string;
}

class TimeZonesSelect extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      search: '',
    };
  }

  searchChange(e: React.FormEvent<HTMLInputElement>) {
    this.setState({
      search: e.currentTarget.value,
    });
  }

  resetSearch() {
    this.setState({ search: '' });
  }

  componentDidMount() {
    const { timezones, getTimeZones } = this.props;
    if (!timezones) getTimeZones();
  }

  timezoneName({ commonName, offset }: TimeZone) {
    return `${commonName} (UTC ${offset})`;
  }

  render() {
    const { timezones, value, onSelect, error, customErrorText } = this.props;

    if (!timezones) {
      return <Loader size={12} />;
    } else {
      const { search } = this.state;

      const listedTimezones = (timezones || [])
        .filter((tz: TimeZone) => !tz.title.startsWith('US/'))
        .filter((tz: TimeZone) => {
          if (search.length <= 2) return true;
          return hasSubstr(tz.title, search) || hasSubstr(tz.offset, search);
        });

      const selectedTimezone = timezones.find(tz => tz.title === value);

      return (
        <Select
          variant={'select'}
          onClick={this.resetSearch.bind(this)}
          title={
            selectedTimezone ? this.timezoneName(selectedTimezone) : undefined
          }
          value={selectedTimezone?.title}
          error={error}
          customErrorText={customErrorText}
        >
          <SelectSearch
            onChange={this.searchChange.bind(this)}
            value={search}
            error={listedTimezones.length === 0}
            sticky
          />
          {listedTimezones.map((timezone: TimeZone) => (
            <SelectItem
              key={timezone.title}
              isSelected={timezone.title === selectedTimezone?.title}
              onSelect={() => onSelect(timezone.title)}
            >
              {this.timezoneName(timezone)}
            </SelectItem>
          ))}
        </Select>
      );
    }
  }
}

const mapStateToProps = ({ app }: ApplicationState) => ({
  timezones: app.timezones,
});

const mapDispatchToProps = {
  getTimeZones,
};

export default connect(mapStateToProps, mapDispatchToProps)(TimeZonesSelect);
